import React from 'react'
import PropTypes from 'prop-types'
import { adFiltersLabels, adsSortTypes, swapOptions, adPriceTypes } from 'SRC/core/constants'
import { formatDateForTableView } from 'SRC/modules/ads/list/functions/functions'
import { capitalize } from 'SRC/utils'
import config from 'SRC/config/config.yaml'

const getEquipmentByGroup = (equipment, group) => {
  const equipmentsByGroup = equipment.filter(eq => eq.grupa === group)
  let values = []
  for (const equipmentByGroup of equipmentsByGroup) {
    values.push(equipmentByGroup.title)
  }

  return values.join(', ')
}

const getSortTextValue = (sortObject) => {
  let text = ''

  if (typeof sortObject === 'string') text = adsSortTypes[sortObject]
  if (typeof sortObject === 'object') {
    if (sortObject.specification) text = `${sortObject.specification.title} - ${sortObject.order}`
    if (sortObject.by) text = adsSortTypes[`${sortObject.by}${sortObject.order}`]
  }

  return text
}

const Header = ({ filterId, date, onClick, onRemove }) => {
  return <header className='sacuvane-pretrage-item-header'>
    <p>Pretraga</p>
    <div className='akcije'>
      <a href='javascript:void(0)'
        onClick={() => onClick(filterId)}>
        <i className='ico-filter-sacuvaj-pretragu ico' />Pretraži
      </a>

      <a href='javascript:void(0)'
        onClick={() => onRemove(filterId)} >
        <i className='ico-obrisati ico' /> Obriši
      </a>
    </div>
    <p className='vreme'>{date}</p>
  </header>
}

const CommonFilter = ({ field, value }) => {
  return value ? <li>
    <p>{adFiltersLabels[field]}:</p>
    <span>{value}</span>
  </li> : null
}

const Brands = ({ items }) => {
  return items && items.length ? <li>
    <p>{adFiltersLabels.brands}:</p>
    <span>{items.map(brand => brand.name).join(', ')}</span>
  </li> : null
}
const Products = ({ items }) => {
  return items && items.length ? <li>
    <p>{adFiltersLabels.products}:</p>
    <span>{items.map(product => product.model).join(', ')}</span>
  </li> : null
}

const Equipment = ({ items }) => {
  if (Array.isArray(items) && items.length) {
    const equipmentGroups = config.adForm.equipmentGroups

    if (Array.isArray(equipmentGroups) && equipmentGroups.length) {
      return equipmentGroups.map(group => {
        const groupItems = getEquipmentByGroup(items, group.code)
        return groupItems.length
          ? <li>
            <p>{capitalize(group.title)}</p>
            <span>{groupItems}</span>
          </li>
          : null
      })
    }
  }

  return null
}

const Swapps = ({ value }) => {
  return (
    <li>
      <p>{adFiltersLabels.swapps}:</p>
      <span>
        {value.category ? `${value.category.title} ` : ''}
        {value.brand ? `- ${value.brand.name} ` : ''}
        {value.product ? `${value.product.model}` : ''}
        {value.specificationValue1 ? `${value.specificationValue1}` : ''}
      </span>
    </li>
  )
}

const Specifications = ({ items }) => {
  return items.length ? (
    items.map(specification => {
      const measure = specification.id.measure ? specification.id.measure : ''

      return <li key={specification.pk}>
        <p>{specification.id.title}:</p>
        <span>
          {specification.value ? `${specification.value} ${measure}` : null}
          {specification.values ? `${specification.values.join(', ')}` : null}
          {specification.range ? `${specification.range.from} - ${specification.range.to} ${measure}` : null}
        </span>
      </li>
    }))
    : null
}

export const Item = ({ filter, onClick, onRemove }) => {
  return <div key={filter.id} className='sacuvane-pretrage-item'>
    <Header filterId={filter.id} onClick={onClick} onRemove={onRemove} date={formatDateForTableView(filter.createdAt)} />
    <div className='sacuvane-pretrage-item-content'>
      <ul>
        {Object.keys(filter).filter(key => key !== 'equipment').map(filterField => {
          switch (filterField) {
            case 'country':
            case 'city':
            case 'userType':
            case 'brand':
              return <CommonFilter key={filterField} field={filterField} value={filter[filterField].name} />
            case 'brands':
              return <Brands key={filterField} items={filter[filterField]} />
            case 'products':
              return <Products key={filterField} items={filter[filterField]} />
            case 'service':
            case 'serviceType':
              return <CommonFilter key={filterField} field={filterField} value={filter[filterField].name} />
            case 'new24':
            case 'loweredPrice':
              return <CommonFilter key={filterField} field={filterField} value={filter[filterField] ? 'Da' : null} />
            case 'priceType':
              return <CommonFilter key={filterField} field={filterField} value={filter[filterField]
                ? Object.values(adPriceTypes).filter(priceType => priceType.id === filter[filterField])[0].title
                : null}
              />
            case 'condition':
              return <CommonFilter key={filterField} field={filterField} value={filter[filterField]
                ? filter[filterField] === 'new' ? 'Novo' : 'Polovno'
                : null}
              />
            case 'swapp':
              const swapp = swapOptions.find(option => option.value === filter[filterField])
              return <CommonFilter key={filterField} field={filterField} value={swapp ? swapp.title : ''} />
            case 'parentCategory':
              return filter[filterField] ? <CommonFilter key={filterField} field='group' value={filter[filterField].title} /> : null
            case 'category':
              return <CommonFilter key={filterField} field={filterField} value={filter[filterField].title} />
            case 'group':
              return <CommonFilter key={filterField} field={filterField} value={!filter.category ? filter[filterField].title : ''} />
            case 'price':
              const price = filter[filterField]
              const priceValue = price ? `${price[0] ? `od ${price[0]} €` : ''} ${price[1] ? `do ${price[1]} €` : ''}` : null
              return <CommonFilter key={filterField} field={filterField} value={priceValue} />
            case 'priceDaily':
              const priceDaily = filter[filterField]
              const priceDailyValue = priceDaily
                ? `${priceDaily[0] ? `od ${priceDaily[0]} €` : ''} ${priceDaily[1]
                  ? `do ${priceDaily[1]} €` : ''}`
                : null
              return <CommonFilter key={filterField} field={filterField} value={priceDailyValue} />
            case 'priceMonthly':
              const priceMonthly = filter[filterField]
              const priceMonthlyValue = priceMonthly
                ? `${priceMonthly[0] ? `od ${priceMonthly[0]} €` : ''} ${priceMonthly[1]
                  ? `do ${priceMonthly[1]} €` : ''}`
                : null
              return <CommonFilter key={filterField} field={filterField} value={priceMonthlyValue} />
            case 'sortBy':
              const sortValue = getSortTextValue(filter[filterField])
              return <CommonFilter key={filterField} field={filterField} value={sortValue} />
            case 'cities':
              return filter[filterField]
                ? <CommonFilter key={filterField} field={filterField} value={filter[filterField].map(city => city.name).join(', ')} />
                : null
            case 'swapps':
              return <Swapps key='swapps' value={filter[filterField]} />
            case 'specifications':
              return <Specifications key='specifications' items={filter[filterField]} />
            default: break
          }
        })}
        <Equipment key='equipment' items={filter.equipment} />
      </ul>
    </div>
  </div>
}

Item.propTypes = {
  filter: PropTypes.shape({
    id: PropTypes.number,
    createdAt: PropTypes.string,
    parentCategory: PropTypes.object,
    category: PropTypes.object,
    group: PropTypes.object,
    new24: PropTypes.bool,
    loweredPrice: PropTypes.bool,
    swapp: PropTypes.string,
    swapps: PropTypes.object,
    priceType: PropTypes.number,
    brand: PropTypes.object,
    brands: PropTypes.array,
    product: PropTypes.object,
    products: PropTypes.array,
    service: PropTypes.object,
    serviceType: PropTypes.object,
    country: PropTypes.object,
    city: PropTypes.object,
    price: PropTypes.array,
    specifications: PropTypes.array,
    equipment: PropTypes.array,
    condition: PropTypes.string,
    sortBy: PropTypes.any
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
}

Header.propTypes = {
  filterId: PropTypes.number,
  date: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
}

CommonFilter.propTypes = {
  field: PropTypes.string,
  value: PropTypes.any
}

Brands.propTypes = {
  items: PropTypes.array
}

Products.propTypes = {
  items: PropTypes.array
}

Equipment.propTypes = {
  items: PropTypes.array
}

Swapps.propTypes = {
  value: PropTypes.shape({
    category: PropTypes.object,
    brand: PropTypes.object,
    product: PropTypes.object,
    specificationValue1: PropTypes.any
  })
}
